import { createFileRoute, redirect } from '@tanstack/react-router';
import { QuizletsPage } from '@/components/QuizletsPage';
import { z } from 'zod';

const searchSchema = z.object({
  tab: z.enum(['decks', 'grouped']).optional().default('decks'),
});

export const Route = createFileRoute('/quizlets/')({
  component: QuizletsPage,
  validateSearch: searchSchema,
  beforeLoad: ({ context }) => {
    const { user, authLoading } = context as { user: any; authLoading: boolean };
    if (authLoading) return;
    if (!user) {
      throw redirect({ to: '/' });
    }
  },
});
